import {
  GET_MIXINGPLANT_REQUEST,
  GET_MIXINGPLANT_ERROR,
  GET_MIXINGPLANT_SUCCESS,
  CREATE_MIXINGPLANT_REQUEST,
  CREATE_MIXINGPLANT_ERROR,
  CREATE_MIXINGPLANT_SUCCESS,
  UPDATE_MIXINGPLANT_REQUEST,
  UPDATE_MIXINGPLANT_ERROR,
  UPDATE_MIXINGPLANT_SUCCESS,
  DELETE_MIXINGPLANT_REQUEST,
  DELETE_MIXINGPLANT_ERROR,
  DELETE_MIXINGPLANT_SUCCESS
} from "../../actions/types";
import reducers from "../common"

const initialState = {};
export default (state = initialState, action) => {

  reducers.init(reducers);

  reducers.GET_ENTITY_REQUEST = GET_MIXINGPLANT_REQUEST;
  reducers.GET_ENTITY_ERROR = GET_MIXINGPLANT_ERROR;
  reducers.GET_ENTITY_SUCCESS = GET_MIXINGPLANT_SUCCESS;
  reducers.CREATE_ENTITY_REQUEST = CREATE_MIXINGPLANT_REQUEST;
  reducers.CREATE_ENTITY_ERROR = CREATE_MIXINGPLANT_ERROR;
  reducers.CREATE_ENTITY_SUCCESS = CREATE_MIXINGPLANT_SUCCESS;
  reducers.UPDATE_ENTITY_REQUEST = UPDATE_MIXINGPLANT_REQUEST;
  reducers.UPDATE_ENTITY_ERROR = UPDATE_MIXINGPLANT_ERROR;
  reducers.UPDATE_ENTITY_SUCCESS = UPDATE_MIXINGPLANT_SUCCESS;
  reducers.DELETE_ENTITY_REQUEST = DELETE_MIXINGPLANT_REQUEST;
  reducers.DELETE_ENTITY_ERROR = DELETE_MIXINGPLANT_ERROR;
  reducers.DELETE_ENTITY_SUCCESS = DELETE_MIXINGPLANT_SUCCESS;
  reducers.entityName = "mixingPlant";

  return reducers.entity(reducers)(state, action);
};
